import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon, CheckIcon, RefreshCwIcon } from 'lucide-react';
export function ConfigurazioneEmailTab() {
  const [emailProvider, setEmailProvider] = useState('cashfirst');
  const [testSuccess, setTestSuccess] = useState<boolean | null>(null);
  const [emailConfig, setEmailConfig] = useState({
    // CashFirst (precompilato e non modificabile)
    cashfirst: {
      smtpServer: 'smtp.cashfirst.cloud',
      smtpPort: '587',
      smtpUsername: 'acme@cashfirst.cloud',
      smtpPassword: '••••••••••••',
      imapServer: 'imap.cashfirst.cloud',
      imapPort: '993',
      imapUsername: 'acme@cashfirst.cloud',
      imapPassword: '••••••••••••'
    },
    // Office 365
    office365: {
      smtpServer: 'smtp.office365.com',
      smtpPort: '587',
      smtpUsername: '',
      smtpPassword: '',
      imapServer: 'outlook.office365.com',
      imapPort: '993',
      imapUsername: '',
      imapPassword: ''
    },
    // Google Workspace
    google: {
      smtpServer: 'smtp.gmail.com',
      smtpPort: '587',
      smtpUsername: '',
      smtpPassword: '',
      imapServer: 'imap.gmail.com',
      imapPort: '993',
      imapUsername: '',
      imapPassword: ''
    },
    // Personalizzato
    custom: {
      smtpServer: '',
      smtpPort: '',
      smtpUsername: '',
      smtpPassword: '',
      imapServer: '',
      imapPort: '',
      imapUsername: '',
      imapPassword: ''
    }
  });
  // Configurazione PEC
  const [pecConfig, setPecConfig] = useState({
    smtpServer: '',
    smtpPort: '',
    smtpUsername: '',
    smtpPassword: '',
    imapServer: '',
    imapPort: '',
    imapUsername: '',
    imapPassword: ''
  });
  const [pecTestSuccess, setPecTestSuccess] = useState<boolean | null>(null);
  const handleProviderChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setEmailProvider(e.target.value);
    setTestSuccess(null);
  };
  const handleConfigChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const {
      value
    } = e.target;
    setEmailConfig({
      ...emailConfig,
      [emailProvider]: {
        ...emailConfig[emailProvider],
        [field]: value
      }
    });
    setTestSuccess(null);
  };
  const handlePecConfigChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const {
      value
    } = e.target;
    setPecConfig({
      ...pecConfig,
      [field]: value
    });
    setPecTestSuccess(null);
  };
  const handleTestConnection = () => {
    // Simulazione test connessione
    setTimeout(() => {
      setTestSuccess(true);
    }, 1500);
  };
  const handleTestPecConnection = () => {
    // Simulazione test connessione PEC
    setTimeout(() => {
      setPecTestSuccess(true);
    }, 1500);
  };
  const handleSaveConfig = () => {
    // Logica per salvare la configurazione
    alert('Configurazione email salvata con successo');
  };
  const handleSavePecConfig = () => {
    // Logica per salvare la configurazione PEC
    alert('Configurazione PEC salvata con successo');
  };
  const isCashfirst = emailProvider === 'cashfirst';
  return <Card data-id="element-1077">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1078">
        Configurazione Email
      </h3>
      <div className="space-y-6" data-id="element-1079">
        <div data-id="element-1080">
          <label htmlFor="emailProvider" className="block text-sm font-medium text-gray-700" data-id="element-1081">
            Provider Email
          </label>
          <select id="emailProvider" name="emailProvider" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={emailProvider} onChange={handleProviderChange} data-id="element-1082">
            <option value="cashfirst" data-id="element-1083">CashFirst Cloud (Default)</option>
            <option value="office365" data-id="element-1084">Microsoft Office 365</option>
            <option value="google" data-id="element-1085">Google Workspace</option>
            <option value="custom" data-id="element-1086">Personalizzato</option>
          </select>
        </div>
        {emailProvider === 'cashfirst' && <div className="rounded-md bg-blue-50 p-4" data-id="element-1087">
            <div className="flex" data-id="element-1088">
              <div className="flex-shrink-0" data-id="element-1089">
                <CheckIcon className="h-5 w-5 text-blue-400" aria-hidden="true" data-id="element-1090" />
              </div>
              <div className="ml-3" data-id="element-1091">
                <h3 className="text-sm font-medium text-blue-800" data-id="element-1092">
                  Configurazione predefinita
                </h3>
                <div className="mt-2 text-sm text-blue-700" data-id="element-1093">
                  <p data-id="element-1094">
                    Stai utilizzando l'indirizzo email predefinito fornito da
                    CashFirst. Questa configurazione è già ottimizzata e non
                    richiede modifiche.
                  </p>
                </div>
              </div>
            </div>
          </div>}
        <div className="space-y-6" data-id="element-1095">
          <div data-id="element-1096">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1097">
              Configurazione SMTP (Posta in Uscita)
            </h4>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-1098">
              <div data-id="element-1099">
                <label htmlFor="smtpServer" className="block text-sm font-medium text-gray-700" data-id="element-1100">
                  Server SMTP
                </label>
                <input type="text" name="smtpServer" id="smtpServer" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].smtpServer} onChange={e => handleConfigChange(e, 'smtpServer')} disabled={isCashfirst} required data-id="element-1101" />
              </div>
              <div data-id="element-1102">
                <label htmlFor="smtpPort" className="block text-sm font-medium text-gray-700" data-id="element-1103">
                  Porta SMTP
                </label>
                <input type="text" name="smtpPort" id="smtpPort" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].smtpPort} onChange={e => handleConfigChange(e, 'smtpPort')} disabled={isCashfirst} required data-id="element-1104" />
              </div>
              <div data-id="element-1105">
                <label htmlFor="smtpUsername" className="block text-sm font-medium text-gray-700" data-id="element-1106">
                  Username SMTP
                </label>
                <input type="text" name="smtpUsername" id="smtpUsername" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].smtpUsername} onChange={e => handleConfigChange(e, 'smtpUsername')} disabled={isCashfirst} required data-id="element-1107" />
              </div>
              <div data-id="element-1108">
                <label htmlFor="smtpPassword" className="block text-sm font-medium text-gray-700" data-id="element-1109">
                  Password SMTP
                </label>
                <input type="password" name="smtpPassword" id="smtpPassword" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].smtpPassword} onChange={e => handleConfigChange(e, 'smtpPassword')} disabled={isCashfirst} required data-id="element-1110" />
              </div>
            </div>
          </div>
          <div data-id="element-1111">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1112">
              Configurazione IMAP (Posta in Entrata)
            </h4>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-1113">
              <div data-id="element-1114">
                <label htmlFor="imapServer" className="block text-sm font-medium text-gray-700" data-id="element-1115">
                  Server IMAP
                </label>
                <input type="text" name="imapServer" id="imapServer" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].imapServer} onChange={e => handleConfigChange(e, 'imapServer')} disabled={isCashfirst} required data-id="element-1116" />
              </div>
              <div data-id="element-1117">
                <label htmlFor="imapPort" className="block text-sm font-medium text-gray-700" data-id="element-1118">
                  Porta IMAP
                </label>
                <input type="text" name="imapPort" id="imapPort" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].imapPort} onChange={e => handleConfigChange(e, 'imapPort')} disabled={isCashfirst} required data-id="element-1119" />
              </div>
              <div data-id="element-1120">
                <label htmlFor="imapUsername" className="block text-sm font-medium text-gray-700" data-id="element-1121">
                  Username IMAP
                </label>
                <input type="text" name="imapUsername" id="imapUsername" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].imapUsername} onChange={e => handleConfigChange(e, 'imapUsername')} disabled={isCashfirst} required data-id="element-1122" />
              </div>
              <div data-id="element-1123">
                <label htmlFor="imapPassword" className="block text-sm font-medium text-gray-700" data-id="element-1124">
                  Password IMAP
                </label>
                <input type="password" name="imapPassword" id="imapPassword" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={emailConfig[emailProvider].imapPassword} onChange={e => handleConfigChange(e, 'imapPassword')} disabled={isCashfirst} required data-id="element-1125" />
              </div>
            </div>
          </div>
        </div>
        {testSuccess !== null && <div className={`rounded-md ${testSuccess ? 'bg-green-50' : 'bg-red-50'} p-4`} data-id="element-1126">
            <div className="flex" data-id="element-1127">
              <div className="flex-shrink-0" data-id="element-1128">
                <CheckIcon className={`h-5 w-5 ${testSuccess ? 'text-green-400' : 'text-red-400'}`} aria-hidden="true" data-id="element-1129" />
              </div>
              <div className="ml-3" data-id="element-1130">
                <h3 className={`text-sm font-medium ${testSuccess ? 'text-green-800' : 'text-red-800'}`} data-id="element-1131">
                  {testSuccess ? 'Connessione riuscita' : 'Errore di connessione'}
                </h3>
                <div className={`mt-2 text-sm ${testSuccess ? 'text-green-700' : 'text-red-700'}`} data-id="element-1132">
                  <p data-id="element-1133">
                    {testSuccess ? 'La configurazione email è corretta e funzionante.' : 'Impossibile connettersi con i parametri forniti. Verifica le credenziali e riprova.'}
                  </p>
                </div>
              </div>
            </div>
          </div>}
        <div className="flex justify-end space-x-3" data-id="element-1134">
          <Button type="button" variant="secondary" onClick={handleTestConnection} icon={<RefreshCwIcon className="h-4 w-4 mr-2" data-id="element-1136" />} disabled={isCashfirst} data-id="element-1135">
            Testa Connessione
          </Button>
          <Button type="button" onClick={handleSaveConfig} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1138" />} disabled={isCashfirst} data-id="element-1137">
            Salva Configurazione
          </Button>
        </div>
      </div>
      {/* Configurazione PEC */}
      <div className="mt-12 pt-6 border-t border-gray-200" data-id="element-1139">
        <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1140">
          Configurazione PEC
        </h3>
        <div className="space-y-6" data-id="element-1141">
          <div data-id="element-1142">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1143">
              Configurazione SMTP (PEC in Uscita)
            </h4>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-1144">
              <div data-id="element-1145">
                <label htmlFor="pecSmtpServer" className="block text-sm font-medium text-gray-700" data-id="element-1146">
                  Server SMTP
                </label>
                <input type="text" name="pecSmtpServer" id="pecSmtpServer" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.smtpServer} onChange={e => handlePecConfigChange(e, 'smtpServer')} required data-id="element-1147" />
              </div>
              <div data-id="element-1148">
                <label htmlFor="pecSmtpPort" className="block text-sm font-medium text-gray-700" data-id="element-1149">
                  Porta SMTP
                </label>
                <input type="text" name="pecSmtpPort" id="pecSmtpPort" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.smtpPort} onChange={e => handlePecConfigChange(e, 'smtpPort')} required data-id="element-1150" />
              </div>
              <div data-id="element-1151">
                <label htmlFor="pecSmtpUsername" className="block text-sm font-medium text-gray-700" data-id="element-1152">
                  Username SMTP
                </label>
                <input type="text" name="pecSmtpUsername" id="pecSmtpUsername" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.smtpUsername} onChange={e => handlePecConfigChange(e, 'smtpUsername')} required data-id="element-1153" />
              </div>
              <div data-id="element-1154">
                <label htmlFor="pecSmtpPassword" className="block text-sm font-medium text-gray-700" data-id="element-1155">
                  Password SMTP
                </label>
                <input type="password" name="pecSmtpPassword" id="pecSmtpPassword" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.smtpPassword} onChange={e => handlePecConfigChange(e, 'smtpPassword')} required data-id="element-1156" />
              </div>
            </div>
          </div>
          <div data-id="element-1157">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1158">
              Configurazione IMAP (PEC in Entrata)
            </h4>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-1159">
              <div data-id="element-1160">
                <label htmlFor="pecImapServer" className="block text-sm font-medium text-gray-700" data-id="element-1161">
                  Server IMAP
                </label>
                <input type="text" name="pecImapServer" id="pecImapServer" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.imapServer} onChange={e => handlePecConfigChange(e, 'imapServer')} required data-id="element-1162" />
              </div>
              <div data-id="element-1163">
                <label htmlFor="pecImapPort" className="block text-sm font-medium text-gray-700" data-id="element-1164">
                  Porta IMAP
                </label>
                <input type="text" name="pecImapPort" id="pecImapPort" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.imapPort} onChange={e => handlePecConfigChange(e, 'imapPort')} required data-id="element-1165" />
              </div>
              <div data-id="element-1166">
                <label htmlFor="pecImapUsername" className="block text-sm font-medium text-gray-700" data-id="element-1167">
                  Username IMAP
                </label>
                <input type="text" name="pecImapUsername" id="pecImapUsername" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.imapUsername} onChange={e => handlePecConfigChange(e, 'imapUsername')} required data-id="element-1168" />
              </div>
              <div data-id="element-1169">
                <label htmlFor="pecImapPassword" className="block text-sm font-medium text-gray-700" data-id="element-1170">
                  Password IMAP
                </label>
                <input type="password" name="pecImapPassword" id="pecImapPassword" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={pecConfig.imapPassword} onChange={e => handlePecConfigChange(e, 'imapPassword')} required data-id="element-1171" />
              </div>
            </div>
          </div>
        </div>
        {pecTestSuccess !== null && <div className={`rounded-md ${pecTestSuccess ? 'bg-green-50' : 'bg-red-50'} p-4 mt-4`} data-id="element-1172">
            <div className="flex" data-id="element-1173">
              <div className="flex-shrink-0" data-id="element-1174">
                <CheckIcon className={`h-5 w-5 ${pecTestSuccess ? 'text-green-400' : 'text-red-400'}`} aria-hidden="true" data-id="element-1175" />
              </div>
              <div className="ml-3" data-id="element-1176">
                <h3 className={`text-sm font-medium ${pecTestSuccess ? 'text-green-800' : 'text-red-800'}`} data-id="element-1177">
                  {pecTestSuccess ? 'Connessione PEC riuscita' : 'Errore di connessione PEC'}
                </h3>
                <div className={`mt-2 text-sm ${pecTestSuccess ? 'text-green-700' : 'text-red-700'}`} data-id="element-1178">
                  <p data-id="element-1179">
                    {pecTestSuccess ? 'La configurazione PEC è corretta e funzionante.' : 'Impossibile connettersi con i parametri forniti. Verifica le credenziali e riprova.'}
                  </p>
                </div>
              </div>
            </div>
          </div>}
        <div className="flex justify-end space-x-3 mt-4" data-id="element-1180">
          <Button type="button" variant="secondary" onClick={handleTestPecConnection} icon={<RefreshCwIcon className="h-4 w-4 mr-2" data-id="element-1182" />} data-id="element-1181">
            Testa Connessione PEC
          </Button>
          <Button type="button" onClick={handleSavePecConfig} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1184" />} data-id="element-1183">
            Salva Configurazione PEC
          </Button>
        </div>
      </div>
    </Card>;
}